import React from 'react';
import '../styles/AdminLogin.css';

export default function AdminFooter() {
  return (
    <footer className="admin-footer">
      <div className="admin-footer-brand">Tedo Bizz</div>
      <div>© 2026 Tedo Bizz. Secure Administrative Portal.</div>
      <nav className="admin-footer-nav">
        <a href="#privacy">Privacy Policy</a>
        <a href="#terms">Terms of Service</a>
        <a href="#audit">Security Audit</a>
      </nav>
    </footer>
  );
}
